export default __webpack_public_path__ + "static/media/bottom_arrow.d45dcce3.svg";